import axiosInstance from './axios-instance';

// Action statuses
export type EstimateHistoryType =
  | 'created'
  | 'updated'
  | 'deleted'
  | 'status_changed'
  | 'saved'
  | 'sent_and_saved'
  | 'exported_to_qb';
export type EstimateHistoryPayloadType = {
  estimateId?: number;
  userId?: number | null;
  accountId?: number | null;
  action: EstimateHistoryType;
  internalNote?: string | null;
  versionedNumber?: string | null;
  userLabel?: string | null;
  qbEstimateNumber?: string | null;
};

export const createEstimateHistory = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`estimate-history/create`, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getEstimateHistory = async (id: number) => {
  try {
    const response = await axiosInstance.get(`estimate-history/get/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
